import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar/Navbar';
import Footer from './Footer/Footer';
import TopBar from './TopBar/TopBar'; // <-- Impor TopBar

const MainLayout = () => {
  return (
    <>
      <TopBar /> {/* <-- Tambahkan TopBar di sini */}
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
    </>
  );
};

export default MainLayout;